import * as React from 'react';
import * as _ from 'underscore';
import { IParameterFieldBaseOptions } from '../ts/ParameterFieldBase';

require('pdc-platform-color');

declare var Color: any;

const ICON_CHECKED_SQUARE_BLACK =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAY0lEQVR4Xr2T0QqAIAxFb7EPbV9Wf2oPBedhuCEDL4iCnjNjdkgaamZ02FPNbBfc3yC2CF8izg1ChQomllWYwA97008ASOAgcADmABdd8P+gEjgTIMnhuo0e1gsCwB1Puf07v5tzFWpkt96mAAAAAElFTkSuQmCC';
//const ICON_CHECKED_SQUARE_QHITE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAUElEQVR42mP4TyFgABNkgiFoAFDpfBAmywCoZhiYj9UAdBtwaMZuADYb8GkmZMB/mGtwacbnBVxgPlGxgMOQ+SRFI67wICkd4IqRQZqUKQEAu9u1UMh0QYQAAAAASUVORK5CYII=";
const ICON_UNCHECKED_SQUARE_BLACK =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJklEQVR4Xu3TMQEAAAiEQLR/53cwAusT4DYGCCYJZJEVKFDg0zsf1TMEGcWLZyUAAAAASUVORK5CYII=';
const ICON_NULL_SQUARE_BLACK =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAANElEQVR4Xu2TMQoAIBDDUvH/Xz5nV7OccHlAaKENUBikoBYSLdgPlaITjOCm5w7yVwV95wPWUAUe/arBgwAAAABJRU5ErkJggg==';
const ICON_CHECKED_SQUARE_WHITE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAUElEQVR42mP4TyFgABNkgiFoAFDpfBAmywCoZhiYj9UAdBtwaMZuADYb8GkmZMB/mGtwacbnBVxgPlGxgMOQ+SRFI67wICkd4IqRQZqUKQEAu9u1UMh0QYQAAAAASUVORK5CYII=';
const ICON_UNCHECKED_SQUARE_WHITE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAG0lEQVR42mP4TyFgABNkglEDRg0YNYDaBlACALj77xERnYZDAAAAAElFTkSuQmCC';
const ICON_NULL_SQUARE_WHITE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVR42mP4TyFgABNkgkFqAEE/jxowIgwYokmZEgAAz1XuIHBRR2gAAAAASUVORK5CYII=';
const ICON_CHECKED_CIRCLE_WHITE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADUSURBVDhPlZLRAYMgDESxc8geLlLHchDYQwfBPexLjqJVP+r70EtyAQx227aFJ7zq21nXdRzHGGPnIAhr7cvekHPGgViWhW1hmiZCOim5xVEtpTQMQylF4ZF5nilhUFgb6KQgfYWFMGg5a3g7XjLQvnc4JRVaQ9/3bUeycguZgOWxIWysfBZPOdASjWMJ/TPWf7AG9uIGFF+PJMFksZliF7KAEM10Siq0huPUbmHiGKTrSxd3exUsdHNxQErHaDWshCRbBvYGgaN+nA+D8HTUh793CB/uImYya2P9wQAAAABJRU5ErkJggg==';
const ICON_UNCHECKED_CIRCLE_WHITE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADQSURBVDhPlZLhGYMgDES1c+geMggM4iAOInvIILqHfXBWtBW/+n60iblLhFiv61o94bX9J5Zlcc61bVsnCEi32ods8N6jIAghMBaGYSDFSSlJEqqN49h13TzPSo9M00QJgdLNgJOC4l9ohEDt4qH1ovSIEwtkDYamafaJJWiPjCBO4Fj8qtMNkp2u9R+igVlsQHkJbhYZQTQYY/q+T8+LYEAWIx2I4HIJghuXEk6Lu1wFjS4WB9qDtXavISXl4fHSs0Gg0OGAgPTrVR9+3lX1Bk/NQw39TjT8AAAAAElFTkSuQmCC';
const ICON_NULL_CIRCLE_WHITE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADVSURBVDhPlZJRFYMwDEVhOsAHCFmFIAQh4AOEFB/dbV5X2CjnwP0YL8lLCunqEEL1hFd6Gtu2Oefatq0NBGGqfdkb5nnGgVjXlWNhHEdCOimZxVBtmqau67z3Co8sy0IJg8LUQCcF6TMMwqBxseFtWKmwAOWzJ8ZN0+wnnlCe8dgQca18Fr8qoyUyxxL6Z613iA2cxQ0ovoLNYkPEhr7vh2Gw/CU0YIuK1zpurQgblxPSQxdXvAoGFS4OSDGGZecaVkKSOQN7g8ChjwME4d+rPvx7V9UHO4FBC3TOtIoAAAAASUVORK5CYII=';
const ICON_UNCHECKED_CIRCLE_BLACK1 =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAzElEQVR42q2TgQ2FIBBDyx46iO6hgziIg8geOojuwc/j5wxB5Mf4m1w0YkvLHU5S0Au4XKBpGs3zrK7r4js4jkPbtmkcx7rAMAxalkXee03TFIn23QoR1i8CLELiacQcuMIdZSKnQAhBfd9HqzUQa993tW0bN4oC2AaljCWk/0cBFLGfZvvlAqe4cF/3Qc65R+0zzn8EiMAJ351+DjpFJ84Irw8xb00NOF3X9Yx8GSTqbhbYiE4VB8lEbJStjAipOsp5xtJlSu9HVeAJPj4ImgHITA0PAAAAAElFTkSuQmCC';
const ICON_CHECKED_CIRCLE_BLACK1 =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA1UlEQVR42q2Tiw2EIBBEhz6kEO0DC6EQC9E+pBDtg8twGbJBj8vFm4REXPbth8UByHgg1wKGYcCyLBjHsXxT53kipYR5nvuAEALWdcW2bYgxFkf91yKE9guARkWWYyvaGIBwQSog54xpmkqqEg9TNnWWdRwHvPclUAG0B7nv9cCeLwASbVrcy1kihFGVBYHcu3f2Gc65Smc/7sQAykI+/wEwZdv9byXoxmoJj5vYXk3vGgne972WfBkkHraz0I45bbeD1I6yln0f3VG2+tQD+z66gF/0AoyXygGUBwfrAAAAAElFTkSuQmCC';

export type IconType = 'checkbox' | 'radio';
export type IValue = boolean | string | any[];
export type SchemeType = 'light' | 'dark';

export interface IBooleanFieldOptions {
    title?: string;
    allowNull?: boolean;
    iconType?: IconType | string;
    addClass?: string; //VR add a class like "margin-top: 12px"

    getTitle?(isInParameterField: boolean): string;
    onChange?(value: boolean, e): void;
}

function getIconSrc(value: boolean, iconType: IconType | string, allowNull: boolean, scheme: SchemeType) {
    let iconChecked, iconUnchecked, iconNull;

    if (iconType == null || iconType === 'checkbox') {
        if (scheme === 'dark') {
            iconChecked = ICON_CHECKED_SQUARE_BLACK;
            iconUnchecked = ICON_UNCHECKED_SQUARE_BLACK;
            iconNull = ICON_NULL_SQUARE_BLACK;
        } else {
            iconChecked = ICON_CHECKED_SQUARE_WHITE;
            iconUnchecked = ICON_UNCHECKED_SQUARE_WHITE;
            iconNull = ICON_NULL_SQUARE_WHITE;
        }
    } else {
        if (scheme === 'dark') {
            iconChecked = ICON_CHECKED_CIRCLE_WHITE;
            iconUnchecked = ICON_UNCHECKED_CIRCLE_WHITE;
            iconNull = ICON_NULL_SQUARE_BLACK;
        } else {
            iconChecked = ICON_CHECKED_CIRCLE_BLACK1;
            iconUnchecked = ICON_UNCHECKED_CIRCLE_BLACK1;
            iconNull = ICON_NULL_CIRCLE_WHITE;
        }
    }

    if (value === true) {
        return iconChecked;
    } else if (value === false || allowNull !== true) {
        return iconUnchecked;
    } else {
        return iconNull;
    }
}

export interface IBooleanFieldProperties<TValue> {
    value?: TValue;
    componentRef?: React.MutableRefObject<HTMLDivElement>;
    tooltip?: string;
    title?: string;
    allowNull?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    iconType?: IconType | string;
    prohibitToggleOnEnter?: boolean; //LL: 15.02.21  default false
    isInParameterField?: boolean;
    scheme?: SchemeType;
    options?: IBooleanFieldOptions;

    getTitle?(isInParameterField: boolean): string;
    onChange?(value: boolean, e): void;
}

function getAllowNull(props: IBooleanFieldProperties<any>) {
    return props.allowNull ?? props.options?.allowNull;
}

export function BooleanPureField(props: IBooleanFieldProperties<boolean>) {
    const processTrigger = React.useCallback(
        (e) => {
            // 79722: Page is scrolling down when "Don't send any notifications" is ticked with the keyboard
            e.stopPropagation();
            e.preventDefault();

            if (props.disabled || props.readOnly) {
                return;
            }

            const oldValue = props.value;

            let newValue: boolean;

            if (oldValue == null) {
                newValue = true;
            } else if (oldValue) {
                newValue = false;
            } else {
                newValue = props.allowNull ?? props.options?.allowNull ? null : true;
            }

            if (props.onChange != null) {
                props.onChange(newValue, e);
            }

            if (props.options?.onChange != null) {
                props.options.onChange(newValue, e);
            }
        },
        [
            props.disabled,
            props.readOnly,
            props.value,
            props.allowNull,
            props.options?.allowNull,
            props.onChange,
            props.options?.onChange
        ]
    );

    const handleOnKeyDown = React.useCallback(
        (e: React.KeyboardEvent<HTMLDivElement>) => {
            //LL: 15.02.21  default false
            if (props.prohibitToggleOnEnter !== true) {
                if (e.code === 'Enter' || e.code === 'Space') {
                    // Enter or Space
                    processTrigger(e);
                }
            } else {
                if (e.code === 'Space') {
                    processTrigger(e);
                }
            }
        },
        [props.prohibitToggleOnEnter, processTrigger]
    );

    const { options } = props;
    const allowNull = getAllowNull(props);

    let title = props.title;

    if (title == null) {
        if (props.getTitle != null) {
            title = props.getTitle(props.isInParameterField);
        } else if (options != null) {
            if (options.getTitle != null) {
                title = options.getTitle(props.isInParameterField);
            } else {
                title = options.title;
            }
        }
    }

    let titleElement: React.JSX.Element;

    if (title != null && title.length > 0) {
        titleElement = <span>{title}</span>;
    }

    return (
        <div
            ref={props.componentRef}
            className={'boolean-field' + (props.disabled || props.readOnly ? ' disabled' : '')}
            title={props.tooltip}
            tabIndex={0}
            onKeyDown={handleOnKeyDown}
        >
            <span className={options?.addClass} onClick={processTrigger}>
                <img
                    src={getIconSrc(
                        props.value,
                        props.iconType ?? options?.iconType,
                        allowNull,
                        props.scheme ?? DEFAULT_SCHEME
                    )}
                />
                {titleElement}
            </span>
        </div>
    );
}

export function normalizeBooleanFieldValue(value: IValue, allowNull: boolean): boolean {
    if (Array.isArray(value)) {
        value = value.length > 0 ? value[0] : null;
    }

    if (value == null) {
        return allowNull ? null : false;
    }

    if (typeof value !== 'boolean') {
        return value == 'true';
    }

    return value;
}

const DEFAULT_SCHEME: SchemeType = 'dark';

export function useSchemeHook(componentRef: React.RefObject<HTMLDivElement>, initialScheme?: SchemeType) {
    const [scheme, setScheme] = React.useState<SchemeType>(initialScheme ?? DEFAULT_SCHEME);
    const divColor = React.useRef<string>(null);

    React.useEffect(() => {
        const color = componentRef.current?.style?.color;

        if (color == null) {
            return;
        }

        if (divColor.current !== color) {
            divColor.current = color;

            let isLight: boolean;

            try {
                //isLight = Color(styles.color).light();
                isLight = Color(color).darken(16).light(); //VR: здесь darken(n) - это чистая залипуха, ибо в AttributeSelector для выделенного нода
                // используется средний цвет типа: rgb(128,128,128). И тогда рисуется белый checkbox на белом фоне...
                // Здесь надо использовать шрифт вместо иконок!!! //todo
            } catch (e) {
                isLight = false;
            }

            const newScheme: SchemeType = isLight ? 'light' : 'dark';

            if (scheme !== newScheme) {
                setScheme(newScheme);
            }
        }
    });

    return scheme;
}

export default function BooleanField(props: IBooleanFieldProperties<IValue>) {
    const [value, setValue] = React.useState<boolean>(normalizeBooleanFieldValue(props.value, getAllowNull(props)));
    const componentRef = React.useRef<HTMLDivElement>(null);
    const scheme = useSchemeHook(componentRef, props.scheme);

    React.useEffect(() => {
        const newValue = normalizeBooleanFieldValue(props.value, getAllowNull(props));

        if (value !== newValue) {
            setValue(newValue);
        }
    }, [props.value, props.allowNull, props.options?.allowNull]);

    const handleOnChange = React.useCallback(
        (value: boolean, e) => {
            setValue(value);
            props.onChange?.(value, e);
        },
        [props.onChange]
    );

    const booleanPureFieldProps: IBooleanFieldProperties<boolean> = {
        ...props,
        componentRef: componentRef,
        value: value,
        scheme: scheme,
        onChange: handleOnChange
    };

    return <BooleanPureField {...booleanPureFieldProps} />;
}
